import { use, useContext, useEffect, useState } from "react";
import "../../Components/Puja At Temple/DarshanTemple.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import DatePicker from "react-date-picker";
import Select from "react-select";
import { ERROR_MESSAGES } from "../GlobalErrorMessage";
import { customSelectStyles, SelectLanguageOptions } from "../../middlewares/Utils";
import { GetPanditListDataAPI } from "../../ApiServices/PanditList/PanditList";
import TempleCodModal from "../Darshan Booking/TempleCodModal";
// import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import axios from "axios";
import {
    BaseUrl,
    GetPhonePayPaymentLink,

} from "../../BaseUrl/BaseUrl";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import "../../Pages/Stepper Form/stepper.css";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { FaqModuleID, ServiceDiscounts } from "../enum";
import {
    LanguageList,
    PoojaAtTemple,
} from "../../ApiServices/Pooja At Temple/PoojaTempleApi";
import { handleProceedRemainingPayment } from "../RazorPay/RazorPayFunction";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { GetUserWalletAmount } from "../../ApiServices/UserWallet/UserWalletApi";
import CouponModal from "../CouponModal";
import CODModal from "../../Pages/PanditBooking/CODModal";

const steps = [
    "Booking Details",
    // "Select Pandit",
    "Booking Preview",
    "Payment Status",
];
const PujaKitDetailsPage = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [showCODModal, setShowCODModal] = useState(null);
    const [orderID, setOrderID] = useState();
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const RazorPayKey = process.env.RazorPayKey;
    const RazorPaySecretKey = process.env.RazorPaySecretKey;
    const RazorPayName = process.env.RazorPayName;
    const location = useLocation();
    const userID = localStorage.getItem("userID");
    const [subscriptionData, setSubscriptionData] = useState({
        USER_ID: userID,
        PKSubPID: 2,
        ValidityInMonths: 3,
        PujaKitPrice: null,
        Discount: null,
        DiscountTypeID: null,
        Description: null,
        PaymentType: null,
        PaidAmount: null,
        CustomerName: null,
        MobileNo: null,
        Address: null,
        CouponCodeID: null,
        CouponCodeAmount: null,
        WalletAmount: null
    });
    const [modelRequestData, setModelRequestData] = useState({
        totalPrice: null,
        amountEntered: null,
    });
    const { setLoader } = useContext(LoaderContext);
    const fromDate = dayjs();

    const product = location.state?.product;
    const pujaDetails = location.state;
    const [languageList, setLanguageList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [appliedCoupon, setAppliedCoupon] = useState({
        CouponCode: null,
        isApplied: false,
        CoupenAmount: 0,
        walletAmount: 0,
        couponCodeID: null
    });
    const [grandTotal, setGrandTotal] = useState(0)
    const [couponAmount, setCouponAmount] = useState(0)
    const [walletAmount, setWalletAmount] = useState(9000)
    const [isWalletApplied, setIsWalletApplied] = useState(false);
    const [couponObj, setCouponObj] = useState({
        userID: userID,
        serviceID: FaqModuleID?.PujaAtTempleBooking,
        subModuleID: [10],
        orderAmount: Math.round(location?.state?.PujaKitPrice) || 0

    })

    useEffect(() => {
        const price = Number(location?.state?.Price) || 0;
        const discount = Number(location?.state?.DiscountedAmount) || 0;

        if (isWalletApplied && appliedCoupon?.isApplied === false) {
            const minAmount = Math.min(price, walletAmount);
            const discountAmount = Math.round(minAmount * 0.5);

            // Always update grand total and coupon amount when wallet is applied
            setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }));
            setCouponAmount(discountAmount);
            setGrandTotal(Math.round(price - discount - discountAmount));
        }

        else if (!isWalletApplied && appliedCoupon?.isApplied === true) {
            const couponValue = Number(appliedCoupon?.CoupenAmount) || 0;
            setCouponAmount(couponValue);
            setGrandTotal(Math.round(price - discount - couponValue));
        }

        else {
            // Neither wallet nor coupon applied
            setAppliedCoupon((prev) => ({ ...prev, walletAmount: 0 }));
            setCouponAmount(0);
            setGrandTotal(Math.round(price - discount));
        }
    }, [isWalletApplied, appliedCoupon?.isApplied]);


    function formatToIndianCurrency(amount) {
        if (!amount) return "";

        const [integerPart, decimalPart] = amount.toString().split(".");

        // Format the integer part using Indian numbering system
        const formattedIntegerPart = integerPart.replace(
            // Match groups of 3 digits initially, then groups of 2 digits
            /(\d)(?=(\d\d)+\d$)/g,
            "$1,"
        );

        // Return the formatted value with the decimal part (if present)
        return decimalPart !== undefined
            ? `${formattedIntegerPart}.${decimalPart}`
            : formattedIntegerPart;
    }

    const prevStep = () => {
        if (currentStep > 0) {
            setAppliedCoupon((prev) => ({
                ...prev, CouponCode: null,
                isApplied: false,
                CoupenAmount: 0,
                walletAmount: 0
            }))
            setIsWalletApplied(false)
            setCurrentStep(currentStep - 1);

        }
    };

    const handleOpenCoupenModal = () => {

        setCouponObj((prev) => ({
            ...prev,
            userID: userID,
            serviceID: 1,
            subModuleID: [
                1,
                2
            ],
            orderAmount: null
        }))
        setModelRequestData((prev) => ({ ...prev, moduleName: 'PujaKit' }))
        setShowModal(true)
    }

    const handleRazorpayPayment = async () => {
        if (subscriptionData?.Address === null || subscriptionData?.Address === undefined || subscriptionData?.Address === '' || subscriptionData?.MobileNo === null || subscriptionData?.MobileNo === undefined || subscriptionData?.MobileNo === '' || subscriptionData?.CustomerName === null || subscriptionData?.CustomerName === undefined || subscriptionData?.CustomerName === '') {
            setError(true)
            return
        } else {
            setError(false)
        }
        let orderIDReturned = null
        let minPayableAmount = modelRequestData.amountEntered
            ? modelRequestData.amountEntered
            : Math.round(grandTotal);

        const PlaceOrderResponse = await handleProceedRemainingPayment(minPayableAmount)

        setLoader(true)
        if (PlaceOrderResponse?.status === 1) {

            axios
                .post(`${BaseUrl}/PujaKitSubscriptionPlanBooking`, {
                    USER_ID: userID,
                    PKSubPID: location?.state?.PKSubPID,
                    ValidityInMonths: location?.state?.ValidityInMonths,
                    PujaKitPrice: location?.state?.Price,
                    Discount: location?.state?.Discount,
                    DiscountTypeID: location?.state?.DiscountTypeID,
                    Description: location?.state?.Description,
                    PaymentType: modelRequestData.amountEntered ? "COD" : "ONLINE", // Cash and Online
                    PaidAmount: Number(minPayableAmount),
                    CustomerName: subscriptionData?.CustomerName,
                    MobileNo: subscriptionData?.MobileNo,
                    Address: subscriptionData?.Address,
                    CouponCodeID: appliedCoupon?.CouponCode,
                    CouponCodeAmount: appliedCoupon?.CoupenAmount,
                    WalletAmount: appliedCoupon?.walletAmount,
                    DiscountAmount: location?.state?.DiscountedAmount,
                    GrandTotal: grandTotal
                })
                .then((res) => {
                    if (res) {
                        console.log(res);
                        setOrderID(res.data.ID);
                        setShowCODModal(false);
                        // nextStep();
                        // localStorage.setItem("orderID", JSON.stringify(res.data.ID));
                        orderIDReturned = res.data.ID;
                        setLoader(false)
                        navigate("/thank-you", {
                            state: { moduleName: "pujaKitSubscription" },
                        });
                    }
                });
        } else if (PlaceOrderResponse?.status === 0) {
            setLoader(false)
            alert('Order Failed !')
        }
    };

    const handleCODClicked = () => {
        if (subscriptionData?.Address === null || subscriptionData?.Address === undefined || subscriptionData?.Address === '' || subscriptionData?.MobileNo === null || subscriptionData?.MobileNo === undefined || subscriptionData?.MobileNo === '' || subscriptionData?.CustomerName === null || subscriptionData?.CustomerName === undefined || subscriptionData?.CustomerName === '') {
            setError(true)
            return
        } else {
            setError(false)
        }
        setModelRequestData((prev) => ({
            ...prev,
            totalPrice: grandTotal,
            moduleName: 'PujaKitSubscription'
        }));
        setShowCODModal(true);
    };


    return (
        <>
            <div style={{ background: "#F1F6F7", paddingTop: "30px" }}>
                {/* Step Indicator */}
                <div className="stepper-wrapper">
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className={`stepper-item ${index < currentStep
                                ? "completed"
                                : index === currentStep
                                    ? "active"
                                    : ""
                                }`}
                        >
                            <div className="step-counter">{index + 1}</div>
                            <div className="step-name" style={{ fontSize: "small" }}>
                                {step}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Step Content */}
                <div
                    className="step-content"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        padding: "10px 30px",
                        background: "#F1F6F7",
                    }}
                >
                    {currentStep === 0 && (
                        <>
                            <div className="booking-details-container ">
                                <div
                                    className="booking-details-left"

                                >
                                    <h5>Booking Details</h5>
                                    <hr />
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                                            <label htmlFor="bookingDate" style={{ textAlign: "left" }}>
                                                Full Name<span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input placeholder="Enter Full Name" className="custom-form-control" type="text" value={subscriptionData?.CustomerName} onChange={((e) => setSubscriptionData((prev) => ({ ...prev, CustomerName: e.target.value })))} />
                                            {error && !subscriptionData?.CustomerName && (
                                                <span className="error-msg">{ERROR_MESSAGES}</span>
                                            )}
                                        </div>
                                        <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                                            <label htmlFor="mobileNumber" style={{ textAlign: "left" }}>
                                                Mobile Number<span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                maxLength={10}
                                                id="mobileNumber"
                                                type="text"
                                                className="custom-form-control"
                                                placeholder="Enter Mobile Number"
                                                value={subscriptionData?.MobileNo || ""}
                                                onChange={(e) => {
                                                    const onlyNumbers = e.target.value.replace(/\D/g, '');
                                                    setSubscriptionData((prev) => ({ ...prev, MobileNo: onlyNumbers }));
                                                }}


                                            />
                                            {error && !subscriptionData?.MobileNo && (
                                                <span className="error-msg">{ERROR_MESSAGES}</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column">
                                            <label htmlFor="address" style={{ textAlign: "left" }}>
                                                Address<span style={{ color: "red" }}>*</span>
                                            </label>
                                            <textarea
                                                id="address"
                                                className="custom-form-control"
                                                value={subscriptionData?.Address || ""}
                                                onChange={(e) => {
                                                    let inputVal = e.target.value.trimStart();
                                                    setSubscriptionData((prev) => ({
                                                        ...prev,
                                                        Address: inputVal,
                                                    }));
                                                }}
                                                placeholder="Enter Shipping Address"
                                            />
                                            {error && !subscriptionData?.Address && (
                                                <span className="error-msg">{ERROR_MESSAGES}</span>
                                            )}
                                        </div>
                                        <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column"></div>{" "}
                                    </div>
                                </div>
                                <div className=" booking-details-right">
                                    <div className="price-summary">
                                        <h5>{location?.state?.Title} Subscription</h5>
                                        <hr />
                                        <ul>
                                            {/* <li>
                                                {appliedCoupon?.isApplied ? (
                                                    <div

                                                        style={{
                                                            backgroundColor: 'rgb(239 178 29)',
                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            cursor: 'pointer',
                                                            // fontWeight: 'bold',
                                                            color: '#000',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <div
                                                            onClick={() => handleOpenCoupenModal()}
                                                            style={{ display: 'flex', alignItems: 'center' }}>

                                                            <span>Applied Coupon</span>
                                                            {appliedCoupon && (
                                                                <>
                                                                    <span
                                                                        style={{
                                                                            border: '1px dotted #333',
                                                                            padding: '2px 6px',
                                                                            borderRadius: '4px',
                                                                            fontSize: '12px',
                                                                            backgroundColor: '#fff',
                                                                            color: '#333',
                                                                            marginLeft: '6px',
                                                                        }}
                                                                    >
                                                                        {appliedCoupon?.CouponCode}
                                                                    </span>

                                                                </>


                                                            )}
                                                        </div>
                                                        <span
                                                            onClick={() => {
                                                                setAppliedCoupon((prev) => ({
                                                                    ...prev, CouponCode: null,
                                                                    isApplied: false,
                                                                    CoupenAmount: 0,
                                                                    walletAmount: 0
                                                                }))
                                                            }}
                                                            style={{
                                                                // border: '1px dotted #333',
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                fontSize: '12px',
                                                                backgroundColor: '#fff',
                                                                color: '#a52444',
                                                                marginLeft: '6px',
                                                            }} >



                                                            Remove

                                                        </span>
                                                        <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                                                    </div>
                                                ) : (
                                                    <div
                                                        onClick={() => setShowModal(true)}
                                                        style={{
                                                            backgroundColor: 'rgb(239 178 29)',
                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            cursor: 'pointer',
                                                            // fontWeight: 'bold',
                                                            color: '#000',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                backgroundColor: '#a52444',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                width: '24px',
                                                                height: '24px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '14px',
                                                                marginRight: '10px',

                                                            }}>
                                                                %
                                                            </div>
                                                            <span style={{ fontWeight: '400' }}>View Coupons & Offers</span>

                                                        </div>
                                                        <span style={{ fontSize: '20px', fontWeight: 'bolder' }}>›</span>
                                                    </div>
                                                )}

                                            </li> */}
                                            {/* {walletAmount > 0 && (
                                                <li style={{ fontSize: 'smaller', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <div

                                                        style={{
                                                            backgroundColor: 'rgb(239 178 29)',
                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',

                                                            color: '#000',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>

                                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', width: '100%' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isWalletApplied}
                                                                    onChange={(e) => {
                                                                        setAppliedCoupon((PREV) => ({
                                                                            ...PREV, CouponCode: null,
                                                                            isApplied: false
                                                                        }))
                                                                        setIsWalletApplied(e.target.checked)
                                                                    }
                                                                    }

                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                                Apply  Wallet Amount -  (₹) {walletAmount}
                                                            </label>
                                                        </div>

                                                    </div>

                                                </li>
                                            )}

                                            <hr></hr> */}
                                            <li>
                                                <span>
                                                    {/* Collected on behalf of pandit <br></br> & paid to pandit: */}
                                                    Puja Kit Price (₹) :
                                                </span>
                                                <span>
                                                    {/* <br></br> */}
                                                    {location.state.Price}
                                                </span>
                                            </li>
                                            {isWalletApplied && appliedCoupon?.isApplied === false ? (
                                                <li style={{ fontSize: 'smaller' }}>
                                                    <span>
                                                        Applied Wallet Amount (₹)

                                                    </span>
                                                    <span>
                                                        {appliedCoupon?.walletAmount}
                                                    </span>
                                                </li>
                                            ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                                                <li style={{ fontSize: 'smaller' }}>
                                                    <span>
                                                        Applied Coupon  Amount (₹)

                                                    </span>
                                                    <span>
                                                        {couponAmount}
                                                    </span>
                                                </li>
                                            ) : ''}



                                            <hr />
                                            {location.state.Discount > 0 && (
                                                <>
                                                    <li>
                                                        {location?.state?.DiscountTypeID === 1 ? (
                                                            <span>
                                                                {/* Collected on beh alf of pandit <br></br> & paid to pandit: */}
                                                                Discount (  {location.state.Discount} %) :
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                {/* Collected on behalf of pandit <br></br> & paid to pandit: */}
                                                                Discount  :
                                                            </span>
                                                        )}

                                                        <span>
                                                            {/* <br></br> */}
                                                            {Math.round(location.state.DiscountedAmount)}
                                                        </span>
                                                    </li>
                                                    <hr></hr>
                                                </>
                                            )}

                                            <li>
                                                <span>Grand Total (₹) :</span>
                                                <span>  {Math.round(grandTotal)}</span>
                                            </li>
                                            <hr></hr>
                                        </ul>
                                        <div className="d-flex justify-content-end">
                                            {/* <button

                                            style={{ padding: "5px 16px", fontSize: "14px" }}
                                            className="Normal-app-btn mx-2"
                                            onClick={handleCODClicked}
                                        >
                                            Cash On Delivery
                                        </button> */}
                                            <button
                                                style={{ padding: "5px 16px", fontSize: "14px", justifyContent: 'end' }}
                                                className="Normal-app-btn"
                                                onClick={handleRazorpayPayment}
                                            >
                                                Pay
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </>
                    )}

                </div>


                <CODModal
                    show={showCODModal}
                    onHide={() => setShowCODModal(false)}
                    onConfirm={handleRazorpayPayment}
                    modelRequestData={modelRequestData}
                    setModelRequestData={setModelRequestData}
                />
                <CouponModal
                    show={showModal}
                    handleClose={() => setShowModal(false)}
                    modelRequestData={modelRequestData}
                    setAppliedCoupon={setAppliedCoupon}
                    setIsWalletApplied={setIsWalletApplied}
                    apiParam={couponObj} />
            </div >
        </>
    )
}

export default PujaKitDetailsPage
